import {
  Alert,
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Radio,
  Select,
  Space,
  Spin,
  Switch,
  Tag,
} from "antd";
import axios from "axios";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import { authenticateToken } from "../../../utils/auth";
import {
  getImgUrl,
  getParamValue,
  getUpdatedUrl,
  checkStatesAndPushToHistory,
} from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation, useParams, useHistory } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import _, { debounce } from "lodash";
import {
  BarcodeOutlined,
  CheckCircleFilled,
  CheckOutlined,
  CloseOutlined,
  DeleteFilled,
  IssuesCloseOutlined,
  ShopOutlined,
  WarningFilled,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";

import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";

import ProductCreateProps from "../../products/index";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons";
import usePrevious from "../../../hooks/PreviousState";

export interface ProductCreateProps {
  total: number;
  categoriesOptions: any[];
  shopsOptions: any[];
  brandsOptions: any[];
  refetch: () => void;
  setType: (val) => void;
  type?: string;
}
const { Option } = Select;

const HubProductList = (params): ReactElement => {
  const history = useHistory();
  const router = useLocation();
  const { hubInfo } = useSelector((state) => (state as any)?.authReducer);
  const hubId = hubInfo?.id;
  const [shopId, setShopId] = useState(getParamValue(router?.search, "shopId"));
  const route = useParams();
  // --------------------------------
  const [loading, setLoading] = useState(false);
  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  // --------------------------------

  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(50);
  const [type, setType] = useState(hubInfo?.type);
  const [visible, setVisible] = useState(undefined);
  const [childrenDrawer, setChildrenDrawer] = useState(undefined);
  const [key, setKey] = useState(getParamValue(router?.search, "key"));
  const [barCode, setBarCode] = useState(
    getParamValue(router?.search, "barCode")
  );
  const [isDeleted, setIsDeleted] = useState(false);
  const [isActive, setIsActive] = useState(
    getParamValue(router?.search, "isActive")
  );
  const [activeSearch, setActiveSearch] = useState(undefined);
  const [activeClone, setActiveClone] = useState(undefined);
  const [changeCat, setChangeCat] = useState(undefined);
  const [changeStatus, setChangeStatus] = useState(undefined);
  const [assignSupplier, setAssignSupplier] = useState(undefined);
  const defaultMinimumStockValue = 10000000;
  const [minimumStock, setMinimumStock] = useState(
    getParamValue(router?.search, "minimumStock") || defaultMinimumStockValue
  ); //useState<any>(10000000);

  const [selectedProductBarcode, setSelectedProductBarcode] = useState([]);
  const [selectedhubId, setSelectedhubId] = useState();
  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [brandId, setBrandId] = useState<any>();
  const [parentCategoryId, setParentCategoryId] = useState(
    getParamValue(router?.search, "parentCategoryId")
  );
  const [childCategoryId, setChildCategoryId] = useState(
    getParamValue(router?.search, "childCategoryId")
  );
  const [targetCategoryId, setTargetCategoryId] = useState<any>();
  const [supplierId, setSupplierId] = useState<any>();
  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [suppliersOptions, setSuppliersOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [hubProductData, setHubProductData] = useState({
    loading: false,
    data: null,
  });

  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const page = getParamValue(router?.search, "page");
  const [form] = Form.useForm();
  const fetchRef = useRef(null);

  const prevShopId = usePrevious(shopId);
  const prevchildCategoryId = usePrevious(childCategoryId);
  const prevIsActive = usePrevious(isActive);
  const prevparentCategoryId = usePrevious(parentCategoryId);
  const prevBarCode = usePrevious(barCode);
  const prevKey = usePrevious(key);
  const prevMinimumStock = usePrevious(minimumStock);

  const reseAllFieldData = () => {
    setKey("");
    setBarCode("");
    setType("");
    setParentCategoryId("");
    setChildCategoryId("");
    setBrandId("");
    setIsActive(null);
    setMinimumStock(1000000);
    form.resetFields();

    history.replace(router.pathname);
    window.location.reload();
  };

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberProductsFilter")
    );
    console.log("rememberProductsFilter: ", retrievedObject);
    if (retrievedObject.barCode) setBarCode(retrievedObject.barCode);
    if (retrievedObject.parentCategoryId)
      setParentCategoryId(retrievedObject.parentCategoryId);
    if (retrievedObject.childCategoryId)
      setChildCategoryId(retrievedObject.childCategoryId);
    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.shopId) setShopId(retrievedObject.shopId);
    if (retrievedObject.minimumStock)
      setMinimumStock(retrievedObject.minimumStock);
    if (retrievedObject.isActive) setIsActive(retrievedObject.isActive);
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }
  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberProductsFilter",
      JSON.stringify({
        barCode: barCode,
        parentCategoryId: parentCategoryId,
        childCategoryId: childCategoryId,
        key: key,
        shopId: shopId,
        isActive: isActive,
        page: page,
        minimumStock: minimumStock,
      })
    );
  };

  // **********************************
  // Search Options
  // **********************************
  const getParentCategoryOptions = useCallback(
    async (val?: string) => {
      setParentCatOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${hubId}&page=0&limit=20` +
          (val ? `&name=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCatOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            value: category?.category?.id,
            label: category?.category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      setCategoriesOptions({ loading: true, list: [] });
      if (hubId) {
        if (parentCategoryId) {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?categoryId=${parentCategoryId}` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        } else {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-hub?hubId=${hubId}&page=0&limit=20` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        }
      } else {
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/categories?shopId=${shopId}&page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.category?.id,
              label: category?.category?.title,
            };
          }),
        });
      }
    },
    [type, parentCategoryId]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&isDeleted=${false}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (hubId ? `&hubId=${hubId}` : ``) +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any; barCode: any }) => {
          return {
            value: product?.barCode,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, key, isDeleted, isActive, hubId]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&isDeleted=${false}` +
          (val ? `&key=${val}` : ``) +
          (hubId ? `&hubId=${hubId}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, barCode, isDeleted, isActive]
  );
  // **********************************
  // Search Options
  // **********************************

  const getHubProducts = useCallback(
    (gethubId) => {
      if (gethubId) {
        try {
          let shouldResetPage = false;
          if (localStorage.getItem("rememberProductsFilter") != null) {
            checkLocalStorageAndSetParams();
            localStorage.removeItem("rememberProductsFilter");
          } else {
            shouldResetPage = checkStatesAndPushToHistory(
              [
                prevShopId,
                prevparentCategoryId,
                prevchildCategoryId,
                prevBarCode,
                prevKey,
                prevIsActive,
                prevMinimumStock,
              ],
              [
                shopId,
                parentCategoryId,
                childCategoryId,
                barCode,
                key,
                isActive,
                minimumStock,
              ],
              [
                "shopId",
                "parentCategoryId",
                "childCategoryId",
                "barCode",
                "key",
                "isActive",
                "minimumStock",
              ],
              history
            );
          }
          setHubProductData({ loading: true, data: undefined });
          axios
            .get(
              `${
                process.env.REACT_APP_CATALOG_READER_API
              }/admin/product?hubId=${gethubId}&isDeleted=${false}` +
                `&page=${shouldResetPage ? 0 : page || 0}` +
                `&limit=${limit || 16}` +
                (status ? `&status=${status}` : ``) +
                (key ? `&key=${key}` : ``) +
                (barCode ? `&barCode=${barCode}` : ``) +
                (shopId ? `&shopId=${shopId}` : ``) +
                (supplierId ? `&supplierId=${supplierId}` : ``) +
                (parentCategoryId
                  ? `&parentCategoryId=${parentCategoryId}`
                  : ``) +
                (childCategoryId ? `&childCategoryId=${childCategoryId}` : ``) +
                (brandId ? `&brandId=${brandId}` : ``) +
                (isActive ? `&isActive=${isActive}` : ``) +
                (minimumStock ? `&minimumStock=${minimumStock}` : ``) +
                (type ? `&type=${type}` : ``),
              {
                headers: {
                  Authorization: `Bearer ${authenticateToken()}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setHubProductData({
                  loading: false,
                  data: data?.data,
                });
                setCheckedList(
                  data.data.products.map((product) => product?.barCode)
                );
              } else {
                setHubProductData({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setHubProductData({ loading: false, data: null });

              console.log(err);
            });
        } catch (error) {
          setHubProductData({ loading: false, data: null });

          console.log(error, "error");
        }
      }
    },

    [
      limit,
      page,
      status,
      shopId,
      supplierId,
      childCategoryId,
      parentCategoryId,
      brandId,
      key,
      barCode,
      type,
      minimumStock,
      isDeleted,
      isActive,
    ]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop?page=0&limit=30` +
          (hubId ? `&hubId=${hubId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [type]
  );

  const getSupplierOptions = useCallback(
    async (val?: string) => {
      setSuppliersOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/supplier/by-shop` +
          (shopId ? `?shopId=${shopId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (page ? `&page=${page}` : ``) +
          (limit ? `&limit=${limit}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setSuppliersOptions({
        loading: false,
        list: res?.data?.suppliers?.map((supplier) => {
          return {
            value: supplier?.id,
            label: supplier?.name,
          };
        }),
      });
    },
    [shopId]
  );

  //
  const onSubmit = async (data: any) => {
    setLoading(true);

    if (assignSupplier) {
      const readyData = data && {
        barCodes: selectedProductBarcode,
        hubId: selectedhubId || hubId,
        supplierId: supplierId,
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/supplier-update`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification(
              "Supplier Successfully in Selected Shop(s)",
              "success"
            );
            getHubProducts(hubId);
            form.resetFields();
            setVisible(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else if (changeCat) {
      const readyData = data && {
        barCodes: selectedProductBarcode,
        hubIds: selectedhubId || [hubId],
        targetCategoryId: targetCategoryId,
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/category-update`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification(
              "Product Changed Category Successfully in Selected Shop(s)",
              "success"
            );
            getHubProducts(hubId);
            form.resetFields();
            setVisible(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else if (activeClone) {
      const readyData = data && {
        sourcehubId: hubId,
        barCodes: selectedProductBarcode,
        hubIds: [selectedhubId || hubId],
      };
      if (hubId === hubInfo?.id) {
        responseNotification("Can't clone product in ", "success");
      } else {
        await fetch(
          `${process.env.REACT_APP_CATALOG_WRITER_API}/product/add-from-product`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(readyData),
          }
        )
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification(
                "Product Cloned Successfully in Selected Shop(s)",
                "success"
              );
              form.resetFields();
              setVisible(false);
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    }
  };

  const onStatusChange = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          // deleted: !val,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getHubProducts(hubId);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const onMultipleStatusChange = async () => {
    if (changeStatus === "DELETEANDACTIVE") {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-inactive-but-active-in-other-shops`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            barCodes: selectedProductBarcode,
            hubId: hubId,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Selected Item(s) Status Updated Successfully",
              "success"
            );
            getHubProducts(hubId);
            setVisible(undefined);
            setChildrenDrawer(undefined);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-active-inactive`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            barCodes: selectedProductBarcode,
            hubIds: selectedhubId || [hubId],
            isActive: changeStatus === "ACTIVE" ? true : false,
            deleted: changeStatus === "DELETE" ? true : false,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Selected Item(s) Status Updated Successfully",
              "success"
            );
            getHubProducts(hubId);
            setVisible(undefined);
            setChildrenDrawer(undefined);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  // const onChange = (e) => {
  //   setSelectedProductBarcode((prevVal: any) => {
  //     const newVal = e;
  //     let newArr = Array.from(prevVal);
  //     const found = prevVal.find((item) => item === newVal);
  //     if (!found) {
  //       newArr.push(newVal);
  //     } else {
  //       newArr = newArr.filter((item) => item !== newVal);
  //     }
  //     return newArr;
  //   });

  //   setIndeterminate(
  //     !!checkedList.length &&
  //       checkedList.length <= selectedProductBarcode.length
  //   );
  //   setCheckAll(checkedList.length === selectedProductBarcode.length);
  // };

  // const onCheckAllChange = (e) => {
  //   setSelectedProductBarcode(e.target.checked ? checkedList : []);
  //   setIndeterminate(false);
  //   setCheckAll(e.target.checked);
  // };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "product") getProductOptions(value);
        else if (field === "productByBarcode")
          getProductByBarcodeOptions(value);
        else if (field === "parentCategory") getParentCategoryOptions(value);
        else if (field === "category") getCategoriesOptions(value);
        else if (field === "brand") getBrandsOptions(value);
        else if (field === "shop") getShopsOptions(value);
        else if (field === "supplier") getSupplierOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getParentCategoryOptions,
    getCategoriesOptions,
    getBrandsOptions,
    getProductOptions,
    getProductByBarcodeOptions,
    getShopsOptions,
    getSupplierOptions,
  ]);

  useEffect(() => {
    getHubProducts(hubId);
  }, [getHubProducts, hubId]);

  useEffect(() => {
    if (activeSearch || changeCat) {
      getShopsOptions();
      getParentCategoryOptions();
      getCategoriesOptions();
      getBrandsOptions();
    }
  }, [
    getBrandsOptions,
    getParentCategoryOptions,
    getCategoriesOptions,
    getShopsOptions,
    activeSearch,
    changeCat,
  ]);

  useEffect(() => {
    if (parentCategoryId) {
      setChildCategoryId(undefined);
      form.resetFields(["sub_category_search"]);
    }
  }, [setChildCategoryId, parentCategoryId]);
  useEffect(() => {
    if (shopId) {
      getSupplierOptions(shopId.toString());
    }
  }, [getSupplierOptions, shopId]);

  useEffect(() => {
    if (changeStatus) {
      form.resetFields();
    }
  }, [changeStatus]);

  useEffect(() => {
    if (activeClone) {
      form.resetFields();
    }
  }, [activeClone]);

  // const showDrawer = () => {
  //   setVisible(true);
  // };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setActiveClone(undefined);
    setChangeCat(undefined);
    setChangeStatus(undefined);
    setAssignSupplier(undefined);
  };
  const onChildrenDrawerClose = () => {
    setChildrenDrawer(undefined);
    setChangeStatus(undefined);
    setChangeStatus(undefined);
  };

  return (
    <React.Fragment>
      <ShopLayout hubId={hubId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Product List"}
                rightarea={
                  <div className="d-flex">
                    {activeSearch ? (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(false);
                          reseAllFieldData();
                        }}
                        danger
                      >
                        <ZoomOutOutlined />
                      </Button>
                    ) : (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(true);
                        }}
                      >
                        <ZoomInOutlined />
                      </Button>
                    )}

                    {/* <Button
                      type="primary"
                      onClick={() => {
                        showDrawer();
                        // setActiveClone(true);
                      }}
                      disabled={!selectedProductBarcode.length}
                      title="Clone Product"
                      className="mx-2"
                    >
                      <SwapOutlined /> Action
                    </Button>
                    <Button
                      onClick={() => {
                        history.push(`/shops/${hubId}/products/add`);
                      }}
                      danger
                      type="primary"
                      icon={<PlusOutlined />}
                      title="Add Product"
                      disabled={
                        hubInfo?.type === "JC_MART" ? !hubInfo?.hubId : false
                      }
                    >
                      Add New
                    </Button> */}
                  </div>
                }
              />

              {activeSearch && (
                <div className="search_area mb-0">
                  <Form form={form} className="search_form">
                    <Form.Item name="barcode_search" initialValue={barCode}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "productByBarcode")}
                        onSelect={(val) => setBarCode(val)}
                        options={productBarcodeOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productBarcodeOptions?.loading ? (
                            <Spin size="small" />
                          ) : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by BarCode"
                          onSearch={(val) => {
                            setBarCode(val);
                          }}
                          enterButton
                          loading={productBarcodeOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item name="product_search" initialValue={key}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "product")}
                        onSelect={(val) => setKey(val.toString())}
                        options={productOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productOptions?.loading ? <Spin size="small" /> : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by Name"
                          onSearch={(val) => {
                            setKey(val);
                          }}
                          enterButton
                          loading={productOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item name="shop_search" initialValue={shopId}>
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Shop"
                        optionFilterProp="children"
                        onChange={(val) => setShopId(val)}
                        onSearch={(e) => handleSearch(e, "shop")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {shopsOptions.list.length ? (
                          <Option value={""}>All Shops</Option>
                        ) : undefined}
                        {shopsOptions.list.map((shop) => (
                          <Option value={shop.value}>{shop.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>

                    {/* {suppliersOptions?.list?.length ? ( */}
                    {suppliersOptions?.list?.length ? (
                      <Form.Item
                        name="supplier_search"
                        initialValue={supplierId}
                      >
                        <Select
                          allowClear
                          autoClearSearchValue
                          showSearch
                          placeholder="Filter by Supplier"
                          optionFilterProp="children"
                          onChange={(val) => setSupplierId(val)}
                          onSearch={(e) => handleSearch(e, "supplier")}
                          filterOption={(input, option) =>
                            option.children
                              .toString()
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          // options={suppliersOptions?.list}
                        >
                          {suppliersOptions?.list?.map((supplier) => (
                            <Option value={supplier.value}>
                              {supplier.label}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    ) : (
                      ``
                    )}

                    <Form.Item
                      name="parentCategory_search"
                      initialValue={parentCategoryId}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Category"
                        optionFilterProp="children"
                        onChange={(val) => setParentCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "parentCategory")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {parentCatOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="sub_category_search"
                      initialValue={childCategoryId}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Sub Category"
                        optionFilterProp="children"
                        onChange={(val) => setChildCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "category")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {categoriesOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="status_search"
                      initialValue={
                        isActive == "true"
                          ? "ACTIVE"
                          : isActive == "false"
                          ? "INACTIVE"
                          : "ALL"
                      }
                    >
                      <Select
                        showSearch
                        placeholder="Status"
                        onChange={(val) => setIsActive(val as string)}
                      >
                        <Select.Option value="">ALL</Select.Option>
                        <Select.Option value={"true"}>ACTIVE</Select.Option>
                        <Select.Option value={"false"}>INACTIVE</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="stock_search"
                      initialValue={
                        minimumStock == defaultMinimumStockValue
                          ? "ALL"
                          : "OUT OF STOCK"
                      }
                    >
                      <Select
                        showSearch
                        placeholder="Minimum Stock"
                        onChange={(val) => setMinimumStock(val)}
                      >
                        <Select.Option value={defaultMinimumStockValue}>
                          ALL{" "}
                        </Select.Option>
                        <Select.Option value="0">OUT OF STOCK</Select.Option>
                      </Select>
                    </Form.Item>
                  </Form>
                  <div className="search_btn">
                    <Button
                      type="primary"
                      size="large"
                      danger
                      onClick={reseAllFieldData}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              )}

              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    {/* <div className="single-product-heading major">
                      <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={
                          checkAll ||
                          selectedProductBarcode?.length === checkedList?.length
                        }
                        className="mr-3"
                      >
                        Check all
                      </Checkbox>
                    </div> */}
                    <div className="single-product-heading">
                      <span>Name</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Vendor</span>
                    </div>
                    <div className="single-product-heading major">
                      <span>Stock & Price</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Status</span>
                    </div>
                  </div>
                </div>
              </div>

              {hubProductData.loading ? (
                <Loading />
              ) : (
                <div className="product-table">
                  <div className="product-table-area">
                    {hubProductData?.data?.products?.length ? (
                      hubProductData?.data?.products?.map(
                        (product: any, index: number) => (
                          <React.Fragment key={index}>
                            {/* <Link
                              to={`/shops/${
                                (route as any)?.hubId as string
                              }/products/${product?.slug}/details`}
                            > */}
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                {/* <Checkbox
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onChange(product?.barCode);
                                    }}
                                    checked={selectedProductBarcode?.find(
                                      (item) => product?.barCode === item
                                    )}
                                    className="mr-3"
                                    value={product?.barCode}
                                  /> */}
                                <Avatar
                                  shape="square"
                                  size={50}
                                  src={getImgUrl(product?.productImage)}
                                  className="mr-3"
                                />
                                <span className="name">{product?.name}</span>
                              </div>

                              <div className="single-product">
                                <ShopOutlined />
                                <span className="name ml-1 text-uppercase">
                                  {product?.shop?.name}
                                </span>
                              </div>
                              <div className="single-product major">
                                <div className="">
                                  {product?.variations?.length
                                    ? product?.variations?.map(
                                        (variant, index) => (
                                          <React.Fragment key={index}>
                                            <div className="d-flex justify-content-start mb-1">
                                              {variant?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {variant?.barCode}
                                                </Tag>
                                              ) : product?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {product?.barCode}
                                                </Tag>
                                              ) : undefined}
                                              <Tag
                                                color={
                                                  variant?.stock < 10
                                                    ? `red`
                                                    : `green`
                                                }
                                              >
                                                {variant?.variationName?.toUpperCase()}
                                                : <b>{variant?.stock || 0}</b>
                                              </Tag>
                                            </div>
                                            <div className="d-flex justify-content-start mb-1">
                                              <Tag>
                                                MRP{" "}
                                                {variant?.price?.currencyCode}
                                                {variant?.price
                                                  ?.discountedPrice ||
                                                  variant?.price?.mrp}
                                                {variant?.price
                                                  ?.discountedPrice &&
                                                  variant?.price
                                                    ?.discountedPrice !==
                                                    variant?.price?.mrp && (
                                                    <span className="text-danger">
                                                      {" "}
                                                      <del>
                                                        {variant?.price
                                                          ?.currencyCode ||
                                                          "Tk"}
                                                        {variant?.price?.mrp}
                                                      </del>
                                                    </span>
                                                  )}
                                              </Tag>
                                              <Tag>
                                                TP {variant?.price?.tp}{" "}
                                                {variant?.price?.currencyCode}
                                              </Tag>
                                            </div>
                                          </React.Fragment>
                                        )
                                      )
                                    : undefined}
                                </div>
                              </div>

                              <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={product?.isActive}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    onStatusChange(product?.id, val);
                                  }}
                                  disabled={
                                    hubInfo?.deleted || product?.shop?.deleted
                                  }
                                />
                              </div>

                              {/* <div className="single-product">
                                  <Button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      history.push(
                                        `/shops/${
                                          (route as any)?.hubId as string
                                        }/products/${product?.slug}/edit`
                                      );
                                    }}
                                  >
                                    <EditOutlined />
                                  </Button>
                                </div> */}
                            </div>
                            {/* </Link> */}
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}
              <PaginationTwo
                {...hubProductData?.data}
                limit={limit}
                page={hubProductData?.data?.currentPageNumber || 0}
              />
            </div>
          </section>
        </>
      </ShopLayout>

      <Drawer
        title={activeClone ? "Clone Product" : "Change Option"}
        placement="right"
        onClose={onClose}
        visible={visible}
        width={580}
      >
        <Radio.Group defaultValue="" buttonStyle="solid" className="mb-5">
          <Radio.Button
            value="clone_product"
            onChange={() => {
              setActiveClone(true);
              setChangeCat(undefined);
              setAssignSupplier(undefined);
              setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            Clone Product
          </Radio.Button>
          <Radio.Button
            value="change_category"
            onChange={() => {
              setChangeCat(true);
              setActiveClone(undefined);
              setAssignSupplier(undefined);
              setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            Change Category
          </Radio.Button>
          <Radio.Button
            value="assign_supplier"
            onChange={() => {
              setAssignSupplier(true);
              setChangeCat(undefined);
              setActiveClone(undefined);
              setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            Assign Supplier
          </Radio.Button>
          <Radio.Button
            value="change_status"
            onChange={() => {
              setChangeStatus(true);
              setChangeCat(undefined);
              setActiveClone(undefined);
              setAssignSupplier(undefined);
              form.resetFields();
            }}
          >
            Change Status
          </Radio.Button>
        </Radio.Group>

        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
          initialValues={{
            hubId: !activeClone ? [hubId] : undefined,
          }}
        >
          <Form.Item label="Product Barcodes">
            <Input.TextArea value={selectedProductBarcode} disabled rows={8} />
          </Form.Item>

          {activeClone && (
            <Alert
              message="Where do you want to CLONE
                the selected items?"
              type="warning"
              banner
              closable
              className="mb-4"
            />
          )}
          {changeStatus && (
            <Alert
              message="Where do you want to make the STATUS change of selected Items"
              type="error"
              banner
              closable
              className="mb-4"
            />
          )}
          {changeCat && (
            <Alert
              message="Where do you want to make the CATEGORY changes"
              type="warning"
              banner
              closable
              className="mb-4"
            />
          )}
          {assignSupplier && (
            <Alert
              message="Please Select A Supplier To Change/Assign Supplier For Selected Items"
              type="info"
              banner
              closable
              className="mb-4"
            />
          )}

          {!assignSupplier && (
            <Form.Item
              style={{ minWidth: "100%" }}
              label="Select Shop"
              name="hubId"
            >
              <Select
                allowClear
                autoClearSearchValue
                mode={changeStatus || changeCat ? "tags" : undefined}
                onSearch={() => {
                  getShopsOptions();
                }}
                onChange={(val) => {
                  setSelectedhubId(val);
                }}
                options={shopsOptions?.list}
                maxTagTextLength={20}
                disabled={
                  shopsOptions?.list?.find((shop) => shop?.id) === hubInfo?.id
                    ? true
                    : false
                }
              ></Select>
            </Form.Item>
          )}

          {!changeStatus && !changeCat && (
            <Form.Item label="Select Supplier" name="supplierId">
              <Select
                allowClear
                autoClearSearchValue
                onSearch={(e) => handleSearch(e, "supplier")}
                onChange={(val) => setSupplierId(val)}
                options={suppliersOptions?.list}
                maxTagTextLength={20}
                // disabled={!hubId || !selectedhubId}
                placeholder="Select Supplier if Needed"
              ></Select>
            </Form.Item>
          )}

          {changeCat && (
            <>
              <Form.Item
                style={{ minWidth: "100%" }}
                label="Select Category"
                name="targetCategoryId"
              >
                <Select
                  allowClear
                  showSearch
                  autoClearSearchValue
                  onSearch={() => {
                    getCategoriesOptions();
                  }}
                  onChange={(val) => {
                    setTargetCategoryId(val);
                  }}
                  options={categoriesOptions?.list}
                  maxTagTextLength={20}
                ></Select>
              </Form.Item>
            </>
          )}

          {changeStatus ? (
            <>
              <Button
                type="dashed"
                danger
                size="large"
                onClick={() => setChildrenDrawer(true)}
              >
                <FontAwesomeIcon icon={faToggleOn} className="mr-2" />
                Change Status
              </Button>
            </>
          ) : (
            <Button
              type="primary"
              danger
              title="Clone Selected Items"
              disabled={!changeCat && !activeClone && !assignSupplier}
              htmlType="submit"
              size="large"
            >
              Submit
            </Button>
          )}
        </Form>

        <Drawer
          title="Change Status"
          width={365}
          closable={false}
          onClose={onChildrenDrawerClose}
          visible={childrenDrawer}
        >
          <Radio.Group>
            <Space direction="vertical">
              <Radio value="1" onChange={() => setChangeStatus("ACTIVE")}>
                <CheckCircleFilled className="text-success" /> ACTIVE SELECTED
                ITEMS
              </Radio>
              <Radio value="2" onChange={() => setChangeStatus("NACTIVE")}>
                <WarningFilled className="text-warning" /> INACTIVE SELECTED
                ITEMS
              </Radio>
              <Radio
                value="3"
                onChange={() => setChangeStatus("DELETEANDACTIVE")}
              >
                <IssuesCloseOutlined className="text-danger mr-1" />
                INACTIVE &amp; ACTIVE IN ANOTHER SHOP
              </Radio>
              <Radio value="4" onChange={() => setChangeStatus("DELETE")}>
                <DeleteFilled className="text-danger" /> DELETE SELECTED ITEMS
              </Radio>
            </Space>
          </Radio.Group>
          <Button
            type="primary"
            danger
            title="Clone Selected Items"
            disabled={!checkedList || !changeStatus}
            htmlType="submit"
            size="large"
            className="mt-4"
            onClick={() => onMultipleStatusChange()}
          >
            Change Status
          </Button>
        </Drawer>
      </Drawer>
    </React.Fragment>
  );
};

export default HubProductList;
